<template>
  <component
    :is="href ? 'a' : 'div'"
    class="main-sidebar-button"
    :class="{
      'main-sidebar-button--active': active,
    }"
    :href="href"
    @click.prevent="onClick"
  >
    <slot />
  </component>
</template>

<script setup lang="ts">
import type { TmNamedRoute } from '@/services/route/types'
import { computed } from '@/composition/vue/compositionApi'
import { getRouterService } from '@/core/container/ioc'

const props = defineProps<{
  route?: TmNamedRoute
  active?: boolean
  skipAction?: boolean
}>()

const emit = defineEmits<{
  click: []
}>()

const routerService = getRouterService()
const href = computed(() => (props.route ? routerService.resolve(props.route).href : undefined))

const onClick = () => {
  emit('click')
  if (props.skipAction || !props.route) return
  routerService.push(props.route)
}
</script>

<style lang="scss" scoped>
@import '@/styles/components/main-sidebar/variables';

.main-sidebar-button {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  padding-left: 16px;
  text-decoration: none;
  color: #d5d5da;
  font-weight: $semi-bold-font;
  border-radius: $border-radius-x;
  cursor: pointer;
  transition: background-color $transition-200ms-ease-in-out;

  &--active {
    color: $white;
    background-color: $menu-item-background-color--active;
  }

  &:hover {
    background-color: $menu-item-background-color--hover;
  }
}
</style>
